import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';

import { axios } from '@/library/axios';
import type { BaseResponse } from '@/types';

import type { Currency } from './types';

const getAllCurrencies = async () => {
  return axios<Currency[], BaseResponse<Currency[]>, void>({
    url: '/fx/exchange-rates?exchange_rate_type=WITH_OM_FX_MARGIN',
    method: 'get',
  });
};

const customOrder = [
  'USD',
  'EUR',
  'JPY',
  'GBP',
  'CNY',
  'AUD',
  'CAD',
  'CHF',
  'HKD',
  'SGD',
  'AED',
  'SAR',
  'MYR',
  'THB',
  'NZD',
  'SEK',
  'KRW',
  'NOK',
  'ZAR',
  'BRL',
  'IDR',
  'PHP',
  'RUB',
  'QAR',
  'OMR',
  'KWD',
  'BHD',
  'LKR',
  'BND',
  'NPR',
  'DKK',
];

export const useCurrencyRates = () => {
  const [currencies, setCurrencies] = useState<Currency[]>([]);

  const { data, isLoading, refetch } = useQuery(
    ['currencies'],
    getAllCurrencies,
    {
      useErrorBoundary: false,
      refetchOnWindowFocus: false,
      retry: 3,
    }
  );

  useEffect(() => {
    const responseBody = data?.data;
    const content = responseBody?.data;
    const newCurrencies = Array.isArray(content) ? content : [];

    newCurrencies.sort(
      (itemA, itemB) =>
        customOrder.indexOf(itemA.currencyCode) -
        customOrder.indexOf(itemB.currencyCode)
    );

    setCurrencies(newCurrencies);
  }, [data]);

  return {
    currencies,
    isLoading,
    refetch,
  };
};
